import { ADD_STATE_DATA } from './state.types';

interface StateDataState {
  states: Array<any>;
}

const initialState: StateDataState = {
  states: [],
};

const stateReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case ADD_STATE_DATA:
      return {
        states: action.payload,
      };
    default:
      return state;
  }
};

export default stateReducer;
